import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleLoginButton from "../components/method-login/google-login";
import "react-toastify/dist/ReactToastify.css";
import { userService } from "../services/userService";
import FacebookLoginButton from "../components/method-login/facebook-login";
const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Regex kiểm tra email hợp lệ
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // Regex kiểm tra mật khẩu mạnh
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  // Xử lý khi thay đổi input
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  // Xử lý khi nhấn nút đăng ký
  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Họ và tên không được để trống!";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email không được để trống!";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Email không hợp lệ!";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Mật khẩu không được để trống!";
    } else if (!passwordRegex.test(formData.password)) {
      newErrors.password =
        "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt!";
    }

    if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPassword = "Mật khẩu nhập lại không khớp!";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        setLoading(true);
        const response = await userService.register(formData);
        toast.success(
          response.data.message ||
            "Đăng ký thành công! Vui lòng kiểm tra email."
        );
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } catch (error) {
        console.error("Lỗi đăng ký:", error);
        const errorMessage =
          error.response?.data?.message ||
          "Đăng ký thất bại! Vui lòng thử lại.";
        toast.error(errorMessage);
      } finally {
        setLoading(false); // Dừng loading sau khi có kết quả
      }
    }
  };
  return (
    <>
      <div className="main-wrapper authentication-wrapper">
        <div className="container-fuild">
          <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-xxl-4 col-lg-6 col-md-6 col-11 mx-auto">
                <div
                  className="p-4 text-center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="assets/img/logo-dark.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="card authentication-card">
                  <div className="card-header">
                    <div className="text-center">
                      <h5 className="mb-1">Đăng kí</h5>
                      <p>Du lịch dễ dàng hơn bao giờ hết – Đăng ký ngay!</p>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <label className="form-label">Họ và tên</label>
                      <div className="input-icon">
                        <span className="input-icon-addon">
                          <i className="isax isax-user"></i>
                        </span>
                        <input
                          type="text"
                          name="fullName"
                          className="form-control form-control-lg"
                          placeholder="Nhập Họ và Tên"
                          value={formData.fullName}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.fullName && (
                        <small className="text-danger">{errors.fullName}</small>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <div className="input-icon">
                        <span className="input-icon-addon">
                          <i className="isax isax-message"></i>
                        </span>
                        <input
                          type="email"
                          name="email"
                          className="form-control form-control-lg"
                          placeholder="Nhập Email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.email && (
                        <small className="text-danger">{errors.email}</small>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Mật khẩu</label>
                      <div className="input-icon">
                        <span className="input-icon-addon">
                          <i className="isax isax-lock"></i>
                        </span>
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="form-control form-control-lg"
                          placeholder="Nhập mật khẩu"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <span
                          className="input-icon-addon toggle-password"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer" }} // Để icon có thể click
                        >
                          <i
                            className={
                              showPassword
                                ? "isax isax-eye"
                                : "isax isax-eye-slash"
                            }
                          ></i>
                        </span>
                      </div>
                      {errors.password && (
                        <small className="text-danger">{errors.password}</small>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Nhập lại mật khẩu</label>
                      <div className="input-icon">
                        <span className="input-icon-addon">
                          <i className="isax isax-lock"></i>
                        </span>
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirmPassword"
                          className="form-control form-control-lg"
                          placeholder="Nhập lại mật khẩu"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                        />
                        <span
                          className="input-icon-addon toggle-password"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          style={{ cursor: "pointer" }} // Để icon có thể click
                        >
                          <i
                            className={
                              showConfirmPassword
                                ? "isax isax-eye"
                                : "isax isax-eye-slash"
                            }
                          ></i>
                        </span>
                      </div>
                      {errors.confirmPassword && (
                        <small className="text-danger">
                          {errors.confirmPassword}
                        </small>
                      )}
                    </div>

                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
                        onClick={handleSubmit}
                        disabled={loading} // Vô hiệu hóa nút khi đang gửi yêu cầu
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                        ) : (
                          <>
                            Đăng kí
                            <i className="isax isax-arrow-right-3 ms-2"></i>
                          </>
                        )}
                      </button>
                    </div>

                    <div className="login-or mb-3">
                      <span className="span-or">Hoặc</span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <GoogleOAuthProvider
                        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                      >
                        <GoogleLoginButton />
                      </GoogleOAuthProvider>
                      <FacebookLoginButton />
                    </div>
                    <div className="d-flex justify-content-center">
                      <p className="fs-14">
                        Đã có tài khoản?{" "}
                        <Link to="/login" className="link-primary fw-medium">
                          Đăng nhập
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="coprright-footer">
          <p className="fs-14">
            Copyright &copy; 2025. All Rights Reserved,{" "}
            <a href="#" className="text-primary fw-medium">
              DreamsTour
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
